// PURE module — no Angular imports — like the other leaf utils in this module.

/**
 * Avatar initials, the conversation-list rule: first letter of the first two
 * words, or the first two letters of a single-word name, uppercased.
 *
 * This is THE initials function. It started as `resolveInitials` on the bubble
 * host while every other surface derived a single `charAt(0)` letter — so the
 * same person read "RA" in the list and "R" in the conversation. Every avatar
 * (list, conversation header, message rows, thread, search, saved, sidebar,
 * team view, switcher, dialogs) resolves through here now; add new surfaces to
 * that list, don't inline another rule.
 */
export function resolveChatInitials(name: string): string {
  const parts = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}
